import React from "react";
import Grid from "@mui/material/Grid";
import { Link } from "react-router-dom";

import routes from "../../../../routes";
import { ReactComponent as ImageOutline } from "../../../../assets/icons/image-outline.svg";
import { StyledUploadLimitComponent, StyledExploreBtn } from "./styled";

export const UploadLimitComponent = () => {
  return (
    <StyledUploadLimitComponent>
      <Grid item xs={12}>
        <ImageOutline alt="image icon" className={"iconContainer"} />
      </Grid>
      <p className={"containerText"}>
        Oops! you have reached the maximum no. of documents uploads. Let&apos;s have someone call
        you back within one day to help you out.
      </p>
      <p className={"containerText"}>
        Looking for other products or services to grow your business?
      </p>
      <Grid item xs={12} className={"btnContainer"}>
        <Link to={routes.quickapplyLanding}>
          <StyledExploreBtn onClick={() => ""} color="primary" variant="contained">
            Explore Now
          </StyledExploreBtn>
        </Link>
      </Grid>
    </StyledUploadLimitComponent>
  );
};
